<script>
import ScreenDeadlines from "./screens/ScreenDeadlines.vue";
import ScreenOptions from "./screens/ScreenOptions.vue";
import ScreenOffer from "./screens/ScreenOffer.vue";
import ScreenDelivery from "./screens/ScreenDelivery.vue";
import ScreenAppearance from "./screens/ScreenAppearance.vue";
import ScreenLanguage from "./screens/ScreenLanguage.vue";
import ScreenLinks from "./screens/ScreenLinks.vue";

const COMPONENTS = {
  deadlines: ScreenDeadlines,
  options: ScreenOptions,
  offer: ScreenOffer,
  delivery: ScreenDelivery,
  appearance: ScreenAppearance,
  language: ScreenLanguage,
  links: ScreenLinks,
};

/** Prikazuje ekran podešavanja po ključu (isti na računaru i telefonu). */
export default {
  name: "SettingsScreen",
  functional: true,
  props: {
    screen: { type: String, required: true },
  },
  render(h, { props }) {
    const component = COMPONENTS[props.screen];
    return component ? h(component, { key: props.screen }) : null;
  },
};
</script>
